import {ButtonBase, ButtonColors, ConcreteButtonProps} from "./button-base";
import React from "react";
import {useServices} from "../../hooks/use-services.hook";
import {observer} from "mobx-react-lite";



interface NeutralButtonProps extends ConcreteButtonProps {
}

export const NeutralButton: React.FC<NeutralButtonProps> = observer((props) => {
    const services = useServices();
    const themeColors = services.theme.currentTheme.colors;

    const buttonColors: ButtonColors = {
        $background: themeColors.darkContrast,
        $color: themeColors.dark,
        $border: themeColors.dark,
        $backgroundActivated: themeColors.dark,
        $colorActivated: themeColors.darkContrast,
        $borderActivated: themeColors.dark
    }

    return (
        <ButtonBase {...props} colors={buttonColors}>
            {props.children}
        </ButtonBase>
    );
});
